<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('societes.parametrageEdition')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-2">
              <b-field :label="$t('societes.tailleLogoX')">
                <b-input v-model="societe.logoTailleX" type="number"></b-input>
              </b-field>
            </div>
            <div class="column is-2">
              <b-field :label="$t('societes.tailleLogoY')">
                <b-input v-model="societe.logoTailleY" type="number"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-6">
      <div class="card">
        <header class="header-card">
          <p> {{ $t('societes.texteEdition.editionDefaut.title') }} </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-12">
              <b-field :label="$t('societes.texteEdition.editionDefaut.devis')">
                <qd-text-editor v-model="societe.texteDevisDefaut" />
              </b-field>
            </div>
            <div class="column is-12">
              <b-field :label="$t('societes.texteEdition.editionDefaut.commande')">
                <qd-text-editor v-model="societe.texteCommandeDefaut" />
              </b-field>
            </div>
            <div class="column is-12">
              <b-field :label="$t('societes.texteEdition.editionDefaut.facture')">
                <qd-text-editor v-model="societe.texteFactureDefaut" />
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-6">
      <div class="card">
        <header class="header-card">
          <p> {{ $t('societes.texteEdition.editionUnitaire.title') }} </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-12">
              <b-field :label="$t('societes.texteEdition.editionUnitaire.devis')">
                <qd-text-editor  v-model="societe.texteDevisUnitaire" />
              </b-field>
            </div>
            <div class="column is-12">
              <b-field :label="$t('societes.texteEdition.editionUnitaire.commande')">
                <qd-text-editor v-model="societe.texteCommandeUnitaire" />
              </b-field>
            </div>
            <div class="column is-12">
              <b-field :label="$t('societes.texteEdition.editionUnitaire.facture')">
                <qd-text-editor v-model="societe.texteFactureUnitaire" />
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('societes.texteEdition.texteEditionSignature.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="$t('societes.texteEdition.texteEditionSignature.devis')">
                <qd-text-editor v-model="societe.texteEditionDevisSignature" />
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.texteEdition.texteEditionSignature.commande')">
                <qd-text-editor v-model="societe.texteEditionCommandeSignature" />
              </b-field>
            </div>
            <div class="column is-6">
              <qd-checkbox v-model="societe.isTextEditionSignatureUnderCard">
      {{ $t(`societes.texteEdition.texteEditionSignature.isTextEditionSignatureUnderCard`) }}
              </qd-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('societes.texteEdition.texteEditionTlpe.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field
                :label="$t('societes.texteEdition.texteEditionTlpe.texteEditionCourrierTlpe')">
                <qd-text-editor v-model="societe.texteEditionCourrierTlpe" />
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('societes.texteEdition.texteInfoBancaire.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field
                :label="$t('societes.texteEdition.texteInfoBancaire.texteEditionInfoPaiement')">
                <qd-text-editor v-model="societe.informationBancairePaiement"/>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
};

</script>
